
import axios from 'axios';
import apiConfig from './apiConfig';
// import { setupErrorInterceptor } from './utils/errorInterceptor';

const apiService = axios.create({
    baseURL: apiConfig.apiUrl,
});

// Store interceptor ID for potential cleanup
// let errorInterceptorId = null;

// /**
//  * Initialize error interceptor with Error Context
//  * This should be called once when the app starts, after ErrorProvider is mounted
//  * @param {Object} errorContext - The Error Context object with showError method
//  * @returns {Function} Cleanup function to remove the interceptor
//  */
// export const initializeErrorHandling = (errorContext) => {
//   // Remove existing interceptor if any
//   if (errorInterceptorId !== null) {
//     apiService.interceptors.response.eject(errorInterceptorId);
//   }

//   // Setup new interceptor
//   errorInterceptorId = setupErrorInterceptor(apiService, errorContext);

//   // Return cleanup function
//   return () => {
//     if (errorInterceptorId !== null) {
//       apiService.interceptors.response.eject(errorInterceptorId);
//       errorInterceptorId = null;
//     }
//   };
// };

export async function fetchData(controller, params, token) {
    try {

        const response = await apiService.get(`/${controller}${params}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function postData(controller, endpoint, data, token) {
    try {
        const response = await apiService.post(`/${controller}${endpoint}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function postLogin(controller, data) {
    try {
        const response = await apiService.post(`/${controller}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
}


export async function updateData(controller, id, data, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function deleteData(controller, id, token) {
    try {
        const response = await apiService.delete(`/${controller}/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function activateData(controller, id, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/activate`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function CommissionData(controller, id, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/Commission`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function SyncData(controller, id, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/update`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function IncompleteData(controller, id, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/incomplete`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function SyncReprint(controller, id, userId, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/${userId}/update`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function definition (expecting id and mid)
export async function masterdataindex(controller, id, mid, token) {
    try {
        const response = await apiService.get(`/${controller}/${id}/${mid}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const VerifyData = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/Verify`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const PurchaseOrderDetailsDelete = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/PODetailsDelete`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ConvertPurchaseOrderToPurchase = async (controller, id, token) => {
    try {
        console.log(`Making PUT request to: /${controller}/${id}/ConvertPurchaseOrderToPurchase`);
        const response = await apiService.put(`/${controller}/${id}/ConvertPurchaseOrderToPurchase`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        console.log('ConvertPurchaseOrderToPurchase response:', response);
        return response.data;
    } catch (error) {
        console.error('ConvertPurchaseOrderToPurchase error:', error);
        throw error;
    }
};

export const ConvertPurchaseOrderVerify = async (controller, id, token) => {
    try {
        console.log(`Making PUT request to: /${controller}/${id}/ConvertPurchaseOrderVerify`);
        const response = await apiService.put(`/${controller}/${id}/ConvertPurchaseOrderVerify`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        console.log('ConvertPurchaseOrderVerify response:', response);
        return response.data;
    } catch (error) {
        console.error('ConvertPurchaseOrderVerify error:', error);
        throw error;
    }
};


export const ConvertToGoodReceipt = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/Togoodreceipt`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ConvertPurchaseVerify = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/Verify`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ConvertQuotationToSalesOrder = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/ConvertQuotationToSalesOrder`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ConvertSaleOrder = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/Convert`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ConvertSaleOrderVerify = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/Verify`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ConvertQuotationVerify = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/ConvertQuotationVerify`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export async function DeleteChildData(controller, path, token) {
    try {
        const response = await apiService.put(`/${controller}/${path}`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting data:", error);
        throw error;
    }
}

export async function updateCustomerTripData(controller, path, id, data, token) {
    try {
        const response = await apiService.put(`/${controller}/${path}/${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating customer trip:", error);
        throw error;
    }
}

export async function getMessages(controller, params, token) {
    try {

        const response = await apiService.get(`/${controller}${params}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function sendMessage(controller, endpoint, data, token) {
    try {
        const response = await apiService.post(`/${controller}${endpoint}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function Einvoice(controller, id,params,token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/${params}`,null,{
            headers:{
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function TemplateUpdate(controller, doctorId, data, token) {
    try {
        const response = await apiService.put(`/${controller}/${doctorId}/${data}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function fetchDairyDetails(controller, fromdate, todate, doctorId, companyId, userId, token) {
    try {
        const response = await apiService.get(`/${controller}/${fromdate}/${todate}/${doctorId}/${companyId}/${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function fetchDoctorDetails(controller, companyId, doctorId, token) {
    try {
        const response = await apiService.get(`/${controller}/${companyId}/${doctorId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const ConvertEnquiryToSale = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/ConvertToSale`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const CashOnDeliveryAllocated = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/CashOnDeliveryAllocated`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


// POST /{controller}/{tmpType}/{id}  — used for user-branch style endpoints
export async function postDataNew(controller, tmpType, id, data, token) {
    try {
        const response = await apiService.post(`/${controller}/${tmpType}/${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}


